<template>
  <div style="padding-bottom: 2.25rem;">
    <div class="col-md-8">
      <h4 class="site-heading my-3"><span>Feature</span></h4>
    </div>
    <div
      class="form-row"
      v-for="(feature, index) in course_features"
      :key="index"
    >
      <div class="form-group col-md-7">
        <input
          class="form-control"
          v-model="feature.title"
          placeholder="Course Feature"
        />
      </div>
      <div class="form-group col-sm-1">
        <button
          type="button"
          class="btn btn-danger btn-sm"
          @click="deleteSelect(index)"
        >
          <i class="fa fa-times"></i> &nbsp;Delete
        </button>
      </div>
    </div>
    <div class="col-sm-8">
      <button type="button" @click="addFeature" class="btn btn-success btn-sm">
        <i class="fa fa-plus"></i> New
      </button>
    </div>
  </div>
</template>
<script>
export default {
  props: ["features"],
  components: {},
  data: () => ({
    course_features: [
      {
        title: "",
      },
    ],
  }),
  components: {},
  methods: {
    addFeature: function () {
      this.course_features.push({
        title: "",
      });
    },
    deleteSelect: function (index) {
      this.course_features.splice(index, 1);
    },
  },
  watch: {
    features: function (val, oldVal) {
      this.course_features = val;
    },
  },
  updated() {
    this.$emit("updateFeatures", this.course_features);
  },
};
</script>
